import { AnaColumn } from "../forms-template.service";

export const ConfigurazionePosizioneCausaleRentri: AnaColumn[] = [
    {
      itemType: "group", colCount: '1', data: [
        { type: 'campo', colVisible: true, dataField: "id", dataType: "", caption: "", hideOnEdit: true },
  
        {
          type: 'campo', dataField: 'idPosizione', dataType: "", name: 'AidPosizione', //posizione rifiuto
          hideOnEdit: false, caption: "Posizione Rifiuto",
          lookup: {
            titolo: 'Posizioni Rifiuti',
            allowAdding: true, allowDeleting: true, allowUpdating: true,
            dataSource: 'PosizioneRifiuti',
            valueExpr: 'id',
            displayExpr: 'descrizione',
            colonne: [
              {
                dataField: 'descrizione',
                dataType: '',
                caption: 'Descrizione'
              }
            ]
          }
        },
        {
          type: 'campo', dataField: "idRegistroRentriCarico", colVisible: true, dataType: "", caption: "Reg. R.E.N.T.R.i carico", hideOnEdit: true,
  
        },
        {
          type: 'campo', dataField: "idRegistroRentriScarico", colVisible: true, dataType: "", caption: "Reg. R.E.N.T.R.i Scarico", hideOnEdit: true,
  
        },
        {
          type: 'campo', dataField: "idRegistroRentriIntermediario", colVisible: true, dataType: "", caption: "Reg. R.E.N.T.R.i intermediario", hideOnEdit: true,
  
        },
        {
          type: 'campo', dataField: "idRegistroRentriTrasporto", colVisible: true, dataType: "", caption: "Reg. R.E.N.T.R.i trasporto", hideOnEdit: true,
  
        },
        {
          type: 'button', dataField: "", colVisible: true, dataType: "", hideOnEdit: true,
  
          button: {
            name: 'AssociaRegistriRentri',
            hint: 'Scarica registri dal R.E.N.T.R.i',
            icon: 'glyphicon icon-icona-app-rentri',
  
            text: 'Associa con R.E.N.T.R.i',
            type: 'text',
            event: 'AssociaRegistriRentri'
          }
        },
        //
      ]
    }
  ]